import { N as NcActionButton } from "./chunks/NcActionButton-D7uypboC.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-B95wg_Q6.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-Cbg5yktN.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-Xepxb1Nk.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-B2bgbBHw.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-JnumflF4.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-BykT5Byh.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-BScPRxTJ.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-C4iIEWY3.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-BJnvmftc.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-DRaKry-f.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import { N as NcAppNavigationNew } from "./chunks/NcAppNavigationNew-BOfIdgIu.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-KbbB-8vX.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-CI_e6Rva.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-BN3w-BCp.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-C7Oywy1u.mjs";
import { N as NcAppSettingsSection } from "./chunks/NcAppSettingsSection-CsGyNFSh.mjs";
import { N as NcAppSettingsShortcutsSection } from "./chunks/NcAppSettingsShortcutsSection-D3ylJW58.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-CEo2tgBa.mjs";
import { N as NcAppSidebarHeader } from "./chunks/NcAppSidebarHeader-CBE4tNYb.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAssistantButton } from "./chunks/NcAssistantButton-CHiZT-vH.mjs";
import NcAssistantContent from "./Components/NcAssistantContent.mjs";
import { N as NcAssistantIcon } from "./chunks/NcAssistantIcon-mcLe7umL.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-BBqomFJ3.mjs";
import { u } from "./chunks/NcAvatar-BBqomFJ3.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-CP2UBH-9.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-BN1Qrbjc.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-OySgLqXi.mjs";
import { N as NcButton } from "./chunks/NcButton-D6Swkr1k.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-Ddl_QlRN.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-q7zkDwqG.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-DlAxFoRr.mjs";
import { N as NcContent } from "./chunks/NcContent-BgMXU5Dv.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-oxV8oMlX.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-oyS__D-B.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-uYQMYeJS.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-enXYuwj8.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-DmRqcm3W.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-Bqjj-wmb.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-ClkGGFdW.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import { N as NcFilePicker } from "./chunks/NcFilePicker-B57HJpaE.mjs";
import { N as NcFormBox } from "./chunks/NcFormBox-Bd7m8ffs.mjs";
import { N as NcFormBoxButton } from "./chunks/NcFormBoxButton-CRL7kucw.mjs";
import { N as NcFormBoxCopyButton } from "./chunks/NcFormBoxCopyButton-BOENrJAS.mjs";
import { N as NcFormBoxSwitch } from "./chunks/NcFormBoxSwitch-bdRBjKGq.mjs";
import { N as NcFormGroup } from "./chunks/NcFormGroup-tW-MwPUj.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderButton } from "./chunks/NcHeaderButton-MEyDJghO.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-jHItu4LV.mjs";
import { N as NcHighlight } from "./chunks/index-CxTT94_h.mjs";
import { N as NcHotkey } from "./chunks/NcHotkey-CpgacYSd.mjs";
import { N as NcHotkeyList } from "./chunks/NcHotkeyList-BYFbKo6_.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Bui9PhAS.mjs";
import { N as NcInputField } from "./chunks/NcInputField-BrzZ8Bne.mjs";
import { N as NcListItem } from "./chunks/NcListItem-Ciok4H4t.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-DdkIQyoP.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-CSeFP0Uz.mjs";
import { N as NcPopover } from "./chunks/NcPopover-BzTp7LfM.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-D7zYeXBH.mjs";
import { N as NcRadioGroup } from "./chunks/NcRadioGroup-D4kc6Jjr.mjs";
import { N as NcRadioGroupButton } from "./chunks/NcRadioGroupButton-B8a5TW2l.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-CFp3GPty.mjs";
import { N as NcMentionBubble } from "./chunks/index-BCqXu_og.mjs";
import { r } from "./chunks/index-BCqXu_og.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-CG7oWfBl.mjs";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/router";
import "@nextcloud/sharing/public";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a, g, b, c, s, d } from "./chunks/referencePickerModal-DnsOMAHk.mjs";
import "./chunks/createElementId-DhjFt1I9.mjs";
import { N, h, c as c2, i, e, r as r2, f, a as a2 } from "./chunks/customPickerElements-BGmuXU7x.mjs";
import "unist-builder";
import "unist-util-visit-parents";
import "./chunks/logger-D3RVzcfQ.mjs";
import { N as NcRichText } from "./chunks/NcRichText-C3Nj11Wy.mjs";
import { N as NcSelect } from "./chunks/NcSelect-DrKzKPZL.mjs";
import { N as NcTextField } from "./chunks/NcTextField-BPhf3E7g.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-U7AIamCl.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-D8pmnLor.mjs";
import { N as NcSelectUsers } from "./chunks/NcSelectUsers-z2bZafO2.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-BwnkZzWL.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-DV-x6Ag7.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-CFvLzGNf.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-C82D8CSK.mjs";
import { N as NcThemeProvider } from "./chunks/NcThemeProvider-BA_zMjAf.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-D4xfdT9T.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-CuCNjhc8.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-DdPPN-cP.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { useFormatDateTime, useFormatRelativeTime, useFormatTime } from "./Composables/useFormatDateTime.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a3, e as e2, g as g2, s as s2 } from "./chunks/emoji-Dtn2mDf7.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { usernameToColor } from "./Functions/usernameToColor.mjs";
import directive from "./Directives/Focus.mjs";
import directive$1 from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSettingsSectionShortcuts: NcAppSettingsShortcutsSection,
  NcAppSettingsShortcutsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcFilePicker,
  NcFormBox,
  NcFormBoxButton,
  NcFormBoxCopyButton,
  NcFormBoxSwitch,
  NcFormGroup,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcHotkey,
  NcHotkeyList,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSettingsShortcutsSection as NcAppSettingsSectionShortcuts,
  NcAppSettingsShortcutsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcFilePicker,
  NcFormBox,
  NcFormBoxButton,
  NcFormBoxCopyButton,
  NcFormBoxSwitch,
  NcFormGroup,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcHotkey,
  NcHotkeyList,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e2 as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b as getProvider,
  c as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  c2 as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  e as registerCustomPickerElement,
  r2 as registerWidget,
  f as renderCustomPickerElement,
  a2 as renderWidget,
  r as richEditor,
  s as searchProvider,
  s2 as setCurrentSkinTone,
  d as sortProviders,
  spawnDialog,
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
